'use client';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../hooks/auth';
type LoginFormInputs = {
  email: string;
  password: string;
};

const LoginWithPass = ({
  rememberMe,
  redirect,
}: {
  rememberMe: boolean;
  redirect: string;
}) => {
  const { login } = useAuth({
    middleware: 'guest',
    redirectIfAuthenticated: redirect || '/account',
  });
  const [status, setStatus] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<LoginFormInputs>();

  const onSubmit = async (data: LoginFormInputs) => {
    await login({
      ...data,
      remember: rememberMe,
      setErrors: (errs) => {
        Object.entries(errs).forEach(([field, messages]: any) => {
          setError(field as keyof LoginFormInputs, {
            type: 'manual',
            message: messages[0],
          });
        });
      },
      setStatus,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row g-3">
        <div className="col-12">
          <label htmlFor="email" className="form-label">
            Phone or Email
          </label>
          <input
            type="text"
            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
            id="email"
            placeholder="Enter your user name or email"
            {...register('email', { required: 'Email or phone is required' })}
          />
          {errors.email && (
            <div className="invalid-feedback">{errors.email.message}</div>
          )}
        </div>

        <div className="col-12">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
            id="password"
            placeholder="Enter your password"
            {...register('password', { required: 'Password is required' })}
          />
          {errors.password && (
            <div className="invalid-feedback">{errors.password.message}</div>
          )}
        </div>

        <div className="col-12">
          <button type="submit" className="trk-btn trk-btn--secondary d-block">
            {isSubmitting ? 'Logging In...' : 'Login'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginWithPass;
